<div class="container">
  <img src="assets/images/icons/error.png">
  <p class="logout-text">{{'profilePage.logout?'| translate}}</p>
  <div class="logout-buttons">
    <button mat-raised-button (click)="logOut()">{{'profilePage.yes'| translate}}</button>
    <button mat-stroked-button (click)="dontLogout()" class="strok">{{'profilePage.no'| translate}}</button>
  </div>
</div>